import api from '.'
import { DistributorsReq } from './distributors.types'

export const DistributorsKey = {
	search: (query: DistributorsReq) => ['distributors', query],
}

const DistributorsApi = {
	search: (query: DistributorsReq) =>
		api
			.get<PaginatedAPIRes<CategorySearchResult[]>>(`/distributors`, { params: query })
			.then((res) => res.data),
}

export default DistributorsApi
